import { NavLink } from "react-router-dom";
import { HouseFill } from "react-bootstrap-icons";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Spinner from "react-bootstrap/Spinner";

const AuthGateLayout = () => {
  return (
    <>
      <Navbar className='bg-body-tertiary'>
        <Container>
          <Navbar.Toggle />
          <Nav className='me-auto'>
            <NavLink to='/dashboards' className='nav-link' end>
              <HouseFill />
            </NavLink>
          </Nav>
        </Container>
      </Navbar>

      <div className='container my-3 text-center'>
        <Spinner animation='grow' variant='secondary' size='sm' />{" "}
        <Spinner animation='grow' variant='secondary' size='sm' />{" "}
        <Spinner animation='grow' variant='secondary' size='sm' />
      </div>
    </>
  );
};

export default AuthGateLayout;
